






























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class TaxCodeView extends Vue {
  public items: Common.TaxCode[] = new Array(0);
  public params: Common.TaxCodeQuery = new Common.TaxCodeQuery();
  public importQuery = new Common.ImportQuery('税区分', 'TaxCode');
  public exportQuery = new Common.ExportQuery('税区分', this.params);
  @Prop() public auditNo:string;

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  
  public async onCreate(obj: Common.TaxCode) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$api.formatter.clearList(false,'taxCode');
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.TaxCode):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public onChange(item: Common.TaxCode){
    if(item.taxType == Common.TaxTypes.NoTax) item.taxRate = 0;
  }

  public isEditable(item: Common.TaxCode):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }
  
  public isEditableRate(item: Common.TaxCode):boolean{
    return item.state == Common.MasterBaseStatus.NotPosted && item.taxType != Common.TaxTypes.NoTax;
  }
}
